
import React from 'react';
import { Button } from '@/components/ui/button';

interface PageNavigationProps {
  pageNumber: number;
  totalPages: number;
  isNextButtonDisabled: boolean;
  isSubmitting: boolean;
  onPrevPage: () => void;
  onNextClick: () => void;
  isStudentAbsent?: boolean;
  isReviewMode?: boolean;
}

const PageNavigation: React.FC<PageNavigationProps> = ({
  pageNumber,
  totalPages,
  isNextButtonDisabled,
  isSubmitting,
  onPrevPage,
  onNextClick,
  isStudentAbsent,
  isReviewMode,
}) => {
  // Determine button text based on current conditions
  const getButtonText = () => {
    if (pageNumber === 2 && isStudentAbsent) {
      return isSubmitting ? 'กำลังส่ง...' : 'ส่งแบบฟอร์ม';
    }
    
    if (isReviewMode) {
      return isSubmitting ? 'กำลังส่ง...' : 'ส่งแบบฟอร์ม';
    }
    
    if (pageNumber === totalPages - 1) { // Last page before review
      return 'ตรวจสอบข้อมูล';
    }
    
    return 'ต่อไป';
  };

  return (
    <div className="flex justify-between mt-8 mb-10">
      {(pageNumber > 1 || isReviewMode) && (
        <Button 
          type="button"
          variant="outline"
          onClick={onPrevPage}
          className="px-6"
        >
          ย้อนกลับ
        </Button>
      )}
      <div className={`${pageNumber > 1 || isReviewMode ? 'ml-auto' : ''}`}>
        <Button 
          type="button"
          onClick={onNextClick}
          disabled={isNextButtonDisabled || isSubmitting}
          className="bg-form-blue hover:bg-form-light-blue px-8"
        >
          {getButtonText()}
        </Button>
      </div>
    </div>
  );
};

export default PageNavigation;
